import { render, staticRenderFns } from "./MessageBanner.vue?vue&type=template&id=2596a3f3&scoped=true&"
import script from "./MessageBanner.vue?vue&type=script&lang=js&"
export * from "./MessageBanner.vue?vue&type=script&lang=js&"
import style0 from "./MessageBanner.vue?vue&type=style&index=0&id=2596a3f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596a3f3",
  null
  
)

export default component.exports